// Auto-generated icon module
const svg = `<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
	<path d="M19.5,4H18V3.4C17.9,2.6,17.3,2,16.5,2h-11C4.7,2,4.1,2.6,4,3.4v15.2C4.1,19.4,4.7,20,5.5,20H7v0.6C7.1,21.4,7.7,22,8.5,22
		h11c0.8,0,1.4-0.6,1.5-1.4V5.4C20.9,4.6,20.3,4,19.5,4z M5,18.6V3.4C5,3.2,5.3,3,5.5,3h11C16.7,3,17,3.2,17,3.4v15.2
		c0,0.2-0.3,0.4-0.5,0.4h-11C5.3,19,5,18.8,5,18.6z M20,20.6c0,0.2-0.3,0.4-0.5,0.4h-11C8.3,21,8,20.8,8,20.6V20h8.5
		c0.8,0,1.4-0.6,1.5-1.4V5h1.5C19.7,5,20,5.2,20,5.4V20.6z" />
</svg>
`;

export { svg as default };
//# sourceMappingURL=it-copy-C9mYMxcE.js.map
